export const OPTIONAL_SERVICE_FRAGILE = 'Fragile';
export const OPTIONAL_SERVICE_DELIVERY_ADVICE = 'DeliveryAdvice';
export const OPTIONAL_SERVICE_EXPRESS = 'Express';
export const OPTIONAL_SERVICE_DELIVER_TO_ADDRESS = 'DeliverToAddres';
export const OPTIONAL_SERVICE_COD = 'CashOnDelivery';
export const OPTIONAL_SERVICE_INSURANCE = 'Insurance';
export const RecipientPays = 'recipientPays';
